import {
    SET_SELECTED_RUN,
    SET_PREVIEW_RUN,
    SET_TIMING_GATES,
    SET_SELECTED_SPLIT,
    RESET_STATE
} from 'actions/ActionTypes';

const handleSetPreviewRun = (state, action) => {
    return {
        ...state,
        previewRun: action.payload.run
    };
};

const handleSetSelectedRun = (state, action) => {
    return {
        ...state,
        selectedRun: action.payload.run
    };
};
const handleSetTimingGates = (state, action) => {
    return {
        ...state,
        timingGates: action.payload.timingGates
    };
};

const handleSetSelectedSplit = (state, action) => {
    return {
        ...state,
        selectedSplit: action.payload.split
    };
};

const resetTimingGateState = () => {
    return INITIAL_STATE;
};

const INITIAL_STATE = {
    previewRun: null,
    selectedRun: null,
    timingGates: [],
    selectedSplit: 1
};
const handlers = {
    [SET_PREVIEW_RUN]: handleSetPreviewRun,
    [SET_SELECTED_RUN]: handleSetSelectedRun,
    [SET_TIMING_GATES]: handleSetTimingGates,
    [SET_SELECTED_SPLIT]: handleSetSelectedSplit,
    [RESET_STATE]: resetTimingGateState
};

const timingGatesReducer = (state = INITIAL_STATE, action = {}) => {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
};

export default timingGatesReducer;

// selectors

export const getPreviewRun = (state) => state.timingGates.previewRun;
export const getSelectedRun = (state) => state.timingGates.selectedRun;
export const getTimingGates = (state) => state.timingGates.timingGates;
export const getSelectedSplit = (state) => state.timingGates.selectedSplit;
